import { Reveal } from "./Reveal";

const PHOTOS = [
  {
    src: "/assets/project-1.jpg",
    alt: "Custom display and crockery unit with warm backlit shelves beside a wooden door",
    tag: "Bespoke Storage",
    title: "Backlit Display & Crockery Unit",
    testId: "gallery-photo-1",
  },
  {
    src: "/assets/project-2.jpg",
    alt: "Modular kitchen with soft-close drawers, pull-out baskets and marble-look backsplash",
    tag: "Modular Kitchen",
    title: "Soft-Close Drawers & Profile Lighting",
    testId: "gallery-photo-2",
  },
  {
    src: "/assets/project-3.jpg",
    alt: "Bathroom vanity with terrazzo tiles, vessel basin and herringbone accent wall",
    tag: "Bathroom Design",
    title: "Terrazzo Vanity with Vessel Basin",
    testId: "gallery-photo-3",
  },
  {
    src: "/assets/project-4.jpg",
    alt: "Wooden grid partition with hanging brass bells against a fluted panel",
    tag: "Decor Detail",
    title: "Brass Bell Puja Partition",
    testId: "gallery-photo-4",
  },
  {
    src: "/assets/project-5.jpg",
    alt: "Two-tone modular kitchen with terracotta base cabinets, fluted backsplash and reeded glass shutters",
    tag: "Modular Kitchen",
    title: "Two-Tone Kitchen with Reeded Glass",
    testId: "gallery-photo-5",
  },
  {
    src: "/assets/project-6.jpg",
    alt: "Living room with terracotta sofas, cane-topped coffee table, wall sconces and display niche",
    tag: "Living Room",
    title: "Terracotta Lounge with Cane Accents",
    testId: "gallery-photo-6",
  },
  {
    src: "/assets/project-7.jpg",
    alt: "Living room with teal L-shaped sofa, framed botanical wall panels and brass sconces",
    tag: "Living Room",
    title: "Botanical Panel Family Lounge",
    testId: "gallery-photo-7",
  },
  {
    src: "/assets/project-8.jpg",
    alt: "Nesting coffee tables in solid wood and woven cane viewed from above",
    tag: "Bespoke Furniture",
    title: "Cane & Wood Nesting Tables",
    testId: "gallery-photo-8",
  },
];

export const Gallery = () => (
  <section id="gallery" className="py-24 px-6 md:px-10 bg-[#FAF6F0]" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto space-y-12">
      <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div className="space-y-3">
          <span className="text-xs uppercase tracking-widest text-[#c88c2a] font-semibold">Visual Portfolio</span>
          <h2 className="font-display text-3xl sm:text-5xl text-[#0D2121]">Recent Spaces &amp; Details</h2>
        </div>
        <p className="text-[#7A6F66] text-sm max-w-md">
          A glimpse into the residential retreats and commercial interiors designed and executed by the Griham team.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {PHOTOS.map((photo, i) => (
          <Reveal key={photo.title} delay={i * 80}>
            <div
              className="group relative aspect-[3/4] overflow-hidden rounded-sm border border-[#0D2121]/10 shadow-sm"
              data-testid={photo.testId}
            >
              <img
                src={photo.src}
                alt={photo.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0D2121]/70 via-transparent to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-6">
                <span className="text-xs uppercase tracking-wider text-[#FAF6F0]/80">{photo.tag}</span>
                <h3 className="font-display text-lg text-[#FAF6F0] font-normal">{photo.title}</h3>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
